import { renderInDocument } from '@spotahome/soyuz/client';

import AboutUsContainer from './main';

renderInDocument(AboutUsContainer);
